import Vue from "vue";
import CoinList from "@/components/widgets/coin-list";

export default {
  name: "roll-transfer-create",
  components: { CoinList },
  data: function () {
    return {
      role: "",
      branch: "",
      branches: [],
      submitting: false,
      coinListEnabled: false, // modal เลือกม้วน

      form: {
        to_branch_id: null,
        remark: "",
      },
      selectedRolls: [],
    };
  },
  computed: {
    destinationBranchOptions() {
      const myBranch = Number(this.branch);
      return (this.branches || []).filter((b) => Number(b.id) !== myBranch);
    },
  },
  async mounted() {
    await Promise.all([this.getRole(), this.loadBranches()]);
  },
  methods: {
    async getRole() {
      const res = await this.$store.dispatch("Auth/getRole", {}, { root: true });
      this.role = res.data.role;
      this.branch = res.data.branch_id;
    },
    async loadBranches() {
      try {
        const res = await Vue.prototype.$axios.get(`${Vue.prototype.$host}/api/v1/branches`);
        const data = res?.data?.data || res?.data || [];
        this.branches = Array.isArray(data) ? data : (data?.data || []);
      } catch (e) {
        this.branches = [];
      }
    },
    displayCode(r) {
      return r.code && r.code !== "null" ? r.code : "-";
    },
    formatLength(n) {
      if (n === null || n === undefined || n === "") return "-";
      return Number(n).toLocaleString("th-TH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    // callback จาก widget เลือกม้วน — โหมด multiple ส่ง array กลับมา (กันซ้ำ/กันสถานะโอนไม่ได้)
    onCoinListClose(e) {
      this.coinListEnabled = false;
      if (!e || !e.status || !e.data) return;
      const rolls = Array.isArray(e.data) ? e.data : [e.data];
      const badStatus = [3, 4, 6, 7, 9]; // หมด/ยกเลิก/เสียหาย/รอเคลม/กำลังโอน
      let skippedBad = 0;
      let skippedDup = 0;
      rolls.forEach((roll) => {
        if (!roll) return;
        if (badStatus.includes(Number(roll.branch_status))) { skippedBad++; return; }
        if (this.selectedRolls.some((r) => r.id === roll.id)) { skippedDup++; return; }
        this.selectedRolls.push(roll);
      });
      if (skippedBad || skippedDup) {
        const added = rolls.length - skippedBad - skippedDup;
        const msg = [];
        if (skippedBad) msg.push(`${skippedBad} ม้วนโอนไม่ได้ (หมด/เสียหาย/กำลังโอน)`);
        if (skippedDup) msg.push(`${skippedDup} ม้วนอยู่ในรายการอยู่แล้ว ไม่ได้เพิ่มซ้ำ`);
        if (added > 0) msg.push(`เพิ่มใหม่ ${added} ม้วน`);
        // เลือกซ้ำล้วน = ผู้ใช้ไม่ได้ทำอะไรผิด บอกเฉย ๆ ไม่ต้องขึ้นหัวข้อว่า "ข้าม"
        const dupOnly = skippedDup && !skippedBad;
        this.$swal({
          icon: dupOnly ? "info" : "warning",
          title: dupOnly ? "ม้วนนี้เลือกไว้แล้ว" : "ข้ามบางม้วน",
          text: msg.join(" · "),
          confirmButtonText: "ตกลง",
        });
      }
    },
    removeRoll(idx) {
      this.selectedRolls.splice(idx, 1);
    },
    async onSubmit() {
      if (!this.form.to_branch_id) {
        return this.swalError("กรุณาเลือกสาขาปลายทาง");
      }
      if (!this.selectedRolls.length) {
        return this.swalError("กรุณาเลือกม้วนอย่างน้อย 1 ม้วน");
      }
      this.submitting = true;
      try {
        const res = await Vue.prototype.$axios.post(`${Vue.prototype.$host}/api/v1/roll-transfers`, {
          to_branch_id: this.form.to_branch_id,
          remark: this.form.remark,
          roll_ids: this.selectedRolls.map((r) => r.id),
        });
        this.$swal({
          icon: "success",
          title: "สร้างใบโอนม้วนสำเร็จ",
          text: `เลขที่: ${res?.data?.document_no || ""}`,
          confirmButtonText: "ตกลง",
        }).then(() => {
          const uuid = res?.data?.uuid;
          this.$router.push(uuid ? `/roll-transfer/${uuid}` : "/roll-transfer");
        });
      } catch (error) {
        this.swalError(error?.response?.data?.message || error?.message || "บันทึกไม่สำเร็จ");
      } finally {
        this.submitting = false;
      }
    },
    swalError(msg) {
      this.$swal({ icon: "error", title: "ผิดพลาด", text: msg, confirmButtonText: "ตกลง" });
    },
  },
};
